isLiveOverride